export const LOCAL_STORAGE_TIMEOUT = 5 * 60 * 1000; // 5 minutes

export const PUBLICATIONS_LOCAL_STORAGE_KEY = 'publicationsList';

export const SEARCH_FACETS_SESSION_STORAGE_KEY = 'searchFacets';

export const SEARCH_PAGE_LOCAL_STORAGE_KEY = 'searchResultsPage';

export const SEARCH_PAGE_METADATA_LOCAL_STORAGE_KEY = 'searchResultsPageMetadata';
